import React from "react";
import { Box, TableCell } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";

// Columna "Operador": nombre del operador asignado; al pasar el mouse (si hay
// permiso y el estado es elegible) se reemplaza por el ícono de editar.
export default function CeldaOperador({
  data,
  operadores,
  permisoEditarOperador,
  handleEditarOperador,
  handlePopoverOpen,
}) {
  return (
    <TableCell align="center">
      <Box
        sx={{
          position: "relative",
          display: "inline-block",
          maxWidth: "100%",
          px: 1,
          ...(permisoEditarOperador() && (data.idEstadoVerificacionSolicitud == 10 || data.idEstadoVerificacionSolicitud == 12) && {
            "&:hover .operadorNombre": {
              opacity: 0,
              visibility: "hidden",
            },
            "&:hover .editIcon": {
              opacity: 1,
              visibility: "visible",
            },
          }),
        }}
      >
        <Box
          className="operadorNombre"
          sx={{
            transition: "opacity 0.2s ease",
            fontWeight: 500,
            textAlign: "center",
            whiteSpace: "nowrap",
          }}
        >
          {operadores.find((o) => o.idUsuario === data.Operador)?.Nombre || "Vacio"}
        </Box>

        {permisoEditarOperador() && (
          <Box
            className="editIcon"
            onClick={() => handleEditarOperador(data)}
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              textAlign: "center",
              opacity: 0,
              visibility: "hidden",
              color: "#6b7280",
              cursor: "pointer",
              transition: "opacity 0.2s ease",
            }}
          >
            <EditIcon fontSize="small" />
          </Box>
        )}
        <span
          style={{
            // pointerEvents: estaDeshabilitado(data)
            //   ? "none"
            //   : "auto",
            // opacity: estaDeshabilitado(data) ? 0.5 : 1,
          }}
        >
          <MoreVertIcon
            onClick={(event) =>
              handlePopoverOpen(event, 9, data)
            }
            style={{ cursor: "pointer" }}
          />
        </span>
      </Box>
    </TableCell>
  );
}
